import { Link } from 'react-router-dom';

export default function Terminos() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="text-blue-600 hover:text-blue-800 font-medium">
            ← Volver a inicio
          </Link>
        </div>

        {/* Content */}
        <div className="bg-white shadow-sm rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            Términos y Condiciones de Uso
          </h1>

          <div className="prose prose-blue max-w-none space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                1. Información General
              </h2>
              <p>
                El presente documento establece los Términos y Condiciones de Uso del sitio web <strong>aurionenergy.es</strong> (en adelante, el "Sitio Web"), propiedad de <strong>AURION ENERGY S.L.</strong> (en adelante, "AURION ENERGY" o "la Empresa").
              </p>
              <p>
                El acceso y uso del Sitio Web atribuye la condición de usuario (en adelante, el "Usuario") e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en estos Términos y Condiciones de Uso, así como de la Política de Privacidad y la Política de Cookies publicadas en el Sitio Web.
              </p>
              <p>
                Le rogamos que lea atentamente estos términos antes de utilizar el Sitio Web. Si no está de acuerdo con estos Términos y Condiciones, le solicitamos que no utilice este Sitio Web.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                2. Datos Identificativos
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Denominación social:</strong> AURION ENERGY S.L.</li>
                <li><strong>Sitio web:</strong> aurionenergy.es</li>
                <li><strong>Correo electrónico:</strong> info@aurionenergy.es</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                3. Objeto y Ámbito de Aplicación
              </h2>
              <p>
                El Sitio Web tiene como objeto proporcionar información sobre los servicios que ofrece AURION ENERGY en el ámbito de las instalaciones fotovoltaicas, sistemas de autoconsumo energético, eficiencia energética y soluciones renovables.
              </p>
              <p>
                Estos Términos y Condiciones regulan el acceso, navegación y uso del Sitio Web, así como las responsabilidades derivadas de su utilización. AURION ENERGY se reserva el derecho a modificar estos términos en cualquier momento, siendo de aplicación la versión publicada en el Sitio Web en el momento del acceso por parte del Usuario.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                4. Condiciones de Acceso y Uso del Sitio Web
              </h2>
              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                4.1. Carácter Gratuito
              </h3>
              <p>
                El acceso al Sitio Web tiene carácter gratuito para los Usuarios, sin perjuicio del coste de conexión a través de la red de telecomunicaciones suministrada por el proveedor de acceso contratado por el Usuario.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                4.2. Registro y Uso Responsable
              </h3>
              <p>
                El Usuario se compromete a hacer un uso adecuado y lícito del Sitio Web, de conformidad con la legislación aplicable, estos Términos y Condiciones, la moral, las buenas costumbres y el orden público.
              </p>
              <p>
                El Usuario se obliga a no utilizar el Sitio Web para:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Realizar actividades ilícitas, ilegales o contrarias a la buena fe y al orden público.</li>
                <li>Difundir contenidos o propaganda de carácter racista, xenófobo, pornográfico-ilegal, de apología del terrorismo o atentatorio contra los derechos humanos.</li>
                <li>Provocar daños en los sistemas físicos y lógicos de AURION ENERGY, de sus proveedores o de terceros.</li>
                <li>Introducir o difundir virus informáticos o cualesquiera otros sistemas físicos o lógicos susceptibles de provocar daños.</li>
                <li>Intentar acceder y, en su caso, utilizar las cuentas de correo electrónico de otros usuarios y modificar o manipular sus mensajes.</li>
                <li>Suplantar la identidad de otro usuario, de las administraciones públicas o de un tercero.</li>
                <li>Reproducir, copiar, distribuir, poner a disposición o de cualquier otra forma comunicar públicamente, transformar o modificar los contenidos sin autorización expresa del titular de los derechos correspondientes.</li>
                <li>Recabar datos con finalidad publicitaria y de remitir publicidad de cualquier clase y comunicaciones con fines de venta u otras de naturaleza comercial sin que medie su previa solicitud o consentimiento.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                5. Contenidos del Sitio Web
              </h2>
              <p>
                Los contenidos del Sitio Web, incluyendo, sin carácter limitativo, textos, fotografías, gráficos, imágenes, iconos, tecnología, software, links y demás contenidos audiovisuales o sonoros, así como su diseño gráfico y códigos fuente, son propiedad de AURION ENERGY o de terceros, sin que puedan entenderse cedidos al Usuario ninguno de los derechos de explotación reconocidos por la normativa vigente en materia de propiedad intelectual sobre los mismos.
              </p>
              <p>
                AURION ENERGY se reserva el derecho a realizar, en cualquier momento y sin necesidad de previo aviso, modificaciones y actualizaciones de la información contenida en el Sitio Web, de la configuración y presentación de éste y de las condiciones de acceso.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                6. Propiedad Intelectual e Industrial
              </h2>
              <p>
                Todos los contenidos del Sitio Web (incluyendo, sin limitación, bases de datos, imágenes, dibujos, gráficos, archivos de texto, audio, vídeo y software) son propiedad de AURION ENERGY o, en su caso, de terceros que han autorizado su uso, y están protegidos por las normas nacionales e internacionales de propiedad intelectual e industrial.
              </p>
              <p>
                El Usuario puede visualizar, imprimir y descargar los contenidos del Sitio Web exclusivamente para su uso personal y privado. Queda expresamente prohibida la reproducción total o parcial de los contenidos del Sitio Web, así como su tratamiento informático, distribución, difusión, modificación, transformación o descompilación, sin el consentimiento previo y por escrito de AURION ENERGY.
              </p>
              <p>
                Las marcas, nombres comerciales o signos distintivos que aparecen en el Sitio Web son titularidad de AURION ENERGY o, en su caso, de terceros, y se encuentran protegidos por las leyes de propiedad industrial. Su exhibición en el Sitio Web no implica la concesión de licencia o autorización alguna para su uso.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                7. Exclusión de Garantías y Responsabilidad
              </h2>
              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                7.1. Disponibilidad del Sitio Web
              </h3>
              <p>
                AURION ENERGY no garantiza la disponibilidad y continuidad del funcionamiento del Sitio Web. Cuando ello sea razonablemente posible, AURION ENERGY advertirá previamente de las interrupciones en el funcionamiento del Sitio Web. Asimismo, AURION ENERGY no garantiza la utilidad del Sitio Web para la realización de ninguna actividad en particular, ni su infalibilidad y, en particular, aunque no de modo exclusivo, que los Usuarios puedan efectivamente utilizar el Sitio Web.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                7.2. Contenidos
              </h3>
              <p>
                AURION ENERGY no garantiza la licitud, fiabilidad, utilidad, veracidad o exactitud de los servicios o de la información que presta a través del Sitio Web. El Sitio Web puede contener errores tipográficos o inexactitudes. AURION ENERGY se reserva el derecho a corregir cualquier error, inexactitud u omisión, y a cambiar o actualizar la información en cualquier momento sin previo aviso.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                7.3. Enlaces a Terceros
              </h3>
              <p>
                El Sitio Web puede contener enlaces o referencias a sitios web de terceros. AURION ENERGY no controla ni se hace responsable de los contenidos, políticas de privacidad o prácticas de sitios web de terceros. El Usuario accede a dichos sitios bajo su propia responsabilidad.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                7.4. Virus y Elementos Dañinos
              </h3>
              <p>
                AURION ENERGY no se hace responsable de los daños o perjuicios de cualquier tipo producidos en el Usuario que traigan causa de fallos o desconexiones en las redes de telecomunicaciones que produzcan la suspensión, cancelación o interrupción del servicio del Sitio Web durante la prestación del mismo o con carácter previo.
              </p>
              <p>
                AURION ENERGY emplea medidas de seguridad técnicas adecuadas para detectar la existencia de virus. No obstante, el Usuario debe ser consciente de que las medidas de seguridad de los sistemas informáticos en Internet no son enteramente fiables y que, por tanto, AURION ENERGY no puede garantizar la inexistencia de virus u otros elementos que puedan producir alteraciones en los sistemas informáticos del Usuario.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                8. Legislación Aplicable y Jurisdicción
              </h2>
              <p>
                Estos Términos y Condiciones se rigen por la legislación española vigente.
              </p>
              <p>
                Para la resolución de cualquier controversia o conflicto que pudiera derivarse del acceso o uso del Sitio Web, las partes acuerdan someterse, con renuncia expresa a cualquier otro fuero que pudiera corresponderles, a los Juzgados y Tribunales del domicilio del Usuario consumidor. En caso de que el Usuario no tenga la condición de consumidor, las partes se someten a los Juzgados y Tribunales de España.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                9. Contacto
              </h2>
              <p>
                Para cualquier consulta, duda o sugerencia relacionada con estos Términos y Condiciones de Uso, puede ponerse en contacto con nosotros a través del correo electrónico <strong>info@aurionenergy.es</strong>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                10. Aceptación de los Términos
              </h2>
              <p>
                El acceso y uso del Sitio Web implica la aceptación expresa y sin reservas de estos Términos y Condiciones de Uso. Si el Usuario no está de acuerdo con estos términos, deberá abstenerse de acceder y utilizar el Sitio Web.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
